import React from "react";
import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";
// Components
import ProjectBox from "../Elements/ProjectBox";
import FullButton from "../Buttons/FullButton";
import products from "../../data/products";

import PdfIcon from "../Elements/PdfIcon";

export default function Projects({ limit, showAllLink }) {
  const list = limit ? products.slice(0, limit) : products;
  return (
    <Wrapper id="projects">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">
              Our Products
            </h1>
            <p className="font10">
            From sample to result, we've got you covered
            </p>
          </HeaderInfo>
          <ProductsGrid className="textCenter">
            {list.map((product, index) => (
              <ProjectBox
                key={product.slug}
                img={product.img}
                title={product.name}
                text={product.shortDescription}
                alt={product.alt}
                delay={index * 0.12}
              >
                <RouterLink to={`/products/${product.slug}`}>
                  <FullButton title="View Details" border />
                </RouterLink>
                <a
                  href={product.brochureHref}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FullButton title="Brochure" icon={<PdfIcon />} />
                </a>
              </ProjectBox>
            ))}
          </ProductsGrid>
          {showAllLink && (
            <AllLink>
              <RouterLink to="/products">
                <FullButton title="View All Products" />
              </RouterLink>
            </AllLink>
          )}

        </div>
      </div>
    </Wrapper>
  );
}
const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  margin-top: 30px;
  align-items: stretch;
  @media (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;
const AllLink = styled.div`
  max-width: 220px;
  margin: 40px auto 0 auto;
  padding-bottom: 60px;
`;
